import React from 'react';
import { IonIcon } from '@ionic/react';

const ButtonTemplate: React.FC<{
  icon?: string | null;
  text: string;
  onClick: () => void;
  isBlack?: boolean;
  isGreen?: boolean;
  isRed?: boolean;
}> = ({ icon, text, onClick, isBlack = false, isGreen = false, isRed= false }) => {


  return (
    <div 
      className="custom-topbar-button" 
      onClick={onClick} 
      style={{
        border: `1px solid lightgray`, 
        borderRadius: '4px', 
        padding: '8px', 
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '4px',
        backgroundColor: isBlack ? '#333333' : isGreen ? '#28bb50' : isRed ? '#cb1a27' : '#F0F0F0',

      }}
    >
      { icon && (
        <div className="icon-container">
          <IonIcon icon={icon} style={{ fontSize: '24px', color: isBlack || isRed ? '#fff' : '#000' }} />
        </div>
      )}
      <div className="text-container" style={{ color: isBlack || isRed ? '#fff' : '#000' }}>
        {text}
      </div>
    </div>
  );
};

export default ButtonTemplate;
